import React from 'react';

export default function HomePageHeader() {
  return (
      <div className="hero-image-coll">
        <div className="hero-text-coll">
          <h2>Instant Inventory</h2>
        </div>
      </div>
  );
}
